import { Icon, List } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import EmptyResults from 'components/EmptyResults'
import ShowMoreButton from 'components/ShowMoreButton'
import { useSelector } from 'react-redux'
import { useTableConfig } from 'modules/Finance/PromisedPayment/subcomponents/Table/hooks/useTableConfig'
import GridSpinner from 'components/UI/GridSpinner'

const PromisedPayments = ({ onShowMore }) => {
  const { t } = useTranslation(['finance'])

  const {
    promisedPayment: {
      data = [],
      pagination: { total = 0 } = {},
      loaded,
      loading,
    } = {},
  } = useSelector((state) => state['finance/promised-payment'])

  const transactions = useMemo(
    () => data.map((item) => ({ ...item, date: item.created_at })),
    [data],
  )

  const { tableState, tableConfig } = useTableConfig({ data: transactions })

  return (
    <>
      {!loaded || (transactions.length === 0 && loading) ? (
        <GridSpinner width={32} />
      ) : (
        <>
          <List
            Loader={() => (
              <GridSpinner
                width={32}
                style={{ height: '100%' }}
              />
            )}
            table={tableState}
            config={tableConfig}
            EmptyComponent={
              !loading && data.length === 0
                ? () => (
                    <EmptyResults
                      header={t('common::empty_results.header')}
                      text={t('common::empty_results.text')}
                      icon={<Icon name={'time-money'} />}
                    />
                  )
                : null
            }
          />
          <ShowMoreButton
            onClick={onShowMore}
            loading={loading}
            current={transactions.length}
            total={total}
          />
        </>
      )}
    </>
  )
}

PromisedPayments.propTypes = {
  onShowMore: PropTypes.func.isRequired,
}

export default PromisedPayments
